const scope = {
    name_exists: 'The scope name {{name}} is already in use',
    name_with_space: 'The name of the scope cannot contain any spaces.',
};
export default Object.freeze(scope);
